module.exports = __webpack_public_path__ + "img/invoice-template-au.74f04b6.webp";